import React from "react";
import { FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import SubmitButton from "components/SubmitButton";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class EmployeeImports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			importErrors: [],
			importMessages: [],
			selectedFile: null,
			fileInputKey: 0,
		};
	}

	resetFileInput = () => {
		this.setState((prev) => ({
			selectedFile: null,
			fileInputKey: prev.fileInputKey + 1,
		}));
	};

	async handleDownloadTemplate() {
		const response = await employeesService.downloadImportTemplate();

		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = "import_template.xlsx";
		a.click();
	}

	handleImport = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		if (this.state.selectedFile) {
			try {
				var formData = new FormData();
				formData.append("filename", this.state.selectedFile);
				const response = await employeesService.prepareImport(formData);

				if (response.ok && !response.has_errors) {
					this.setState(
						{
							isLoading: false,
							errors: {},
							importMessages: [],
							importErrors: [],
						},
						() => {
							if (response.token) {
								this.runImport(response.token);
							}
						}
					);
				} else if (!response.ok) {
					this.setState({
						isLoading: false,
						submitted: true,
						importMessages: [],
						importErrors: [],
						errors: {
							message: this.props.t("employees.import.errorGeneric"),
						},
					});
				} else {
					var importErrors = [];
					if (Array.isArray(response.rows) && response.rows.length > 0) {
						importErrors = importErrors.concat(response.rows);
					}
					if (response.header && Array.isArray(response.header.errors) && response.header.errors.length > 0) {
						importErrors = importErrors.concat(response.header.errors);
					}

					this.setState({
						isLoading: false,
						submitted: true,
						errors: response.rows && response.rows.length > 0 ? {} : response.errors?.[0] || {},
						importMessages: [],
						importErrors,
					});
				}
			} catch (error) {
				console.error("Error during import:", error);
				this.resetFileInput();
				this.setState({
					isLoading: false,
					submitted: true,
					importMessages: [],
					importErrors: [],
					errors: {
						message: this.props.t("employees.import.errorGeneric"),
					},
				});
			}
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t("employees.import.errorNoFile"),
				},
			});
		}
	};

	runImport = async (token) => {
		this.setState({ isLoading: true });

		try {
			const response = await employeesService.runImport(token);

			if (response.ok) {
				this.setState((prev) => ({
					isLoading: false,
					selectedFile: null,
					fileInputKey: prev.fileInputKey + 1,
					errors: {},
					importErrors:
						response.has_errors && response.rows.length > 0 ? response.rows : [],
					importMessages: response.rows.length > 0 ? response.rows : [],
				}));
			} else {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: errorFormating(response),
				});
			}
		} catch (error) {
			console.error("Error during import:", error);
			this.resetFileInput();
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t("employees.import.errorGeneric"),
				},
			});
		}
	};

	getImportErrors = (rows = [], headerErrors = []) => {
		const rowErrors = rows.map((row, i) => {
			const hasErrors = row.errors && row.errors.length > 0;
			if (!hasErrors) {
				return <li key={`row-${i}`} className="hidden"></li>;
			}
			return (
				<li key={`row-${i}`}>
					<span className="import-count">{this.props.t("employees.import.row")} {row.row}</span>
					<ul className="import-details">
						{this.getImportErrorsDetails(row.errors)}
					</ul>
				</li>
			);
		});

		const headerErrorMessages = Array.isArray(headerErrors)
			? headerErrors.map((error, i) => (
				<li key={`header-${i}`}>
					<span className="import-header-error">{error.message}</span>
				</li>
			))
			: [];

		return [...headerErrorMessages, ...rowErrors];
	};

	getImportErrorsDetails = (errors) =>
		(errors || []).map((error, i) => {
			return <li key={i}>{error.message}</li>;
		});

	getImportMessages = (rows) =>
		rows.map((row, i) => {
			if (!row.errors || row.errors.length > 0) return false;
			return (
				<li key={i}>
					<span className="import-count">{this.props.t("employees.import.row")} {row.row}</span>
					<span className="import-text">{row.message}</span>
				</li>
			);
		});

	handleChange = (event) => {
		this.setState({
			selectedFile: event.target.files[0],
		});
	};

	getContent = () => {
		const { t } = this.props;
		return (
			<form key={this.state.fileInputKey} onSubmit={this.handleImport}>
				<ol className="steps">
					<li className="step-download">
						{t("employees.import.downloadStep")}{" "}
						<span
							className="link"
							onClick={() => this.handleDownloadTemplate()}
						>
							{t("employees.import.downloadTemplate")}
						</span>{" "}
						{t("employees.import.downloadSuffix")}
					</li>
					<li className="step-upload">
						<div className="step-upload-content">
							{t("employees.import.uploadStep")}
							<FormControl
								type="file"
								onChange={this.handleChange}
								className="form-control"
							/>
						</div>
					</li>
				</ol>
				<SubmitButton
					type="submit"
					isLoading={this.state.isLoading}
					text={t("employees.import.submit")}
					loadingText={t("employees.import.submitting")}
				/>
			</form>
		);
	};

	render() {
		const { t } = this.props;
		const { importErrors, importMessages, errors } = this.state;

		return (
			<Layout className="page-imports">
				<div className="heading">
					<div className="heading-left">
						<h1 className="title">{t("employees.import.title")}</h1>
					</div>
				</div>

				{this.getContent()}

				{errors.message && <p className="error-message">{errors.message}</p>}

				{importErrors.length > 0 && (
					<div className="import-list import-errors">
						<p className="import-list-text">
							{t("employees.import.errorsFound")}
						</p>
						<ul className="import-rows">
							{this.getImportErrors(
								importErrors.filter(row => row.row),
								importErrors.filter(error => !error.row)
							)}
						</ul>
					</div>
				)}

				{importMessages.length > 0 && (
					<div className="import-list import-messages">
						<p className="import-list-text">{t("employees.import.importResult")}</p>
						<ul className="import-rows">
							{this.getImportMessages(importMessages)}
						</ul>
					</div>
				)}
			</Layout>
		);
	}
}

export default withTranslation()(EmployeeImports);
